<div class="container-fluid">

    <button type="button" class="close clr-pri-text cursor-po-c h1" (click)="closeDialog()">&times;</button>

    <!-- Select Product -->
    <section *ngIf="currentStep == 0">
        <div class="row payment-dialog-container">
            <div class="col-md-8 offset-2 text-center">
                <i class="fa fa-shopping-cart h3 p-3 fab-fa-icon"></i>
                <h2>{{'gen_subscribe' | translate}}</h2>
                <p>{{'subscribe_asset_msg' | translate}}</p>
            </div>

            <div class="col-md-12">
                <swiper class="swiper-container" fxFlex="auto" [config]="swipConfig" *ngIf="data.products?.length">
                    <div class="swiper-slide my-3" *ngFor="let product of data.products">
                        <div class="product-card">
                            <!-- Title -->
                            <div class="product-header py-3">
                                <h4>{{product.title}}</h4>
                            </div>

                            <!-- <p>{{product.description}}</p> -->
                            <div class="product-info py-4">
                                <!-- Price -->
                                <h3 class="display-4 pt-4">
                                    {{env.priceUnit + product.price}}
                                </h3>

                                <!-- Product label -->
                                <p class="clr-sec-text" *ngIf="product.type == 0 && product.durationHours == 720">
                                    {{'gen_per_month' | translate}}
                                </p>

                                <!-- Duration -->
                                <p class="clr-sec-text">
                                    <span *ngIf="product.durationHours > 24">
                                        {{product.durationHours / 24}} {{'gen_duration_days' | translate}}
                                    </span>
                                    <span *ngIf="product.durationHours <= 24">
                                        {{product.durationHours}} {{'gen_duration_hours' | translate}}
                                    </span>
                                </p>

                                <!-- Action Button -->
                                <mat-divider></mat-divider>

                                <button class="button mt-4 mx-auto" (click)="selectProduct(product)"
                                    *ngIf="!product.isSubscribed">
                                    <i class="pr-1 fa fa-shopping-cart"></i>
                                    {{ "gen_subscribe" | translate}}
                                </button>

                                <!-- More Info -->
                                <p class="clr-theme cursor-po-c py-3" matTooltip="{{product.description}}"
                                    matTooltipClass="theme-tooltip">{{'consent_more_info' | translate}}</p>
                            </div>
                        </div>
                    </div>
                </swiper>
            </div>
        </div>
    </section>

    <!-- Add Receipt Info -->
    <section *ngIf="currentStep == 0.1">
        <app-update-subscriber-info [dialogRef]="dialogRef" (onUpdate)="onSaveInfo()"></app-update-subscriber-info>
    </section>

    <!-- Select Payment Method -->
    <section *ngIf="currentStep == 1">
        <div class="row payment-dialog-container justify-content-center">
            <!-- Confirm Messages -->
            <div class="col-md-12 text-center">
                <i class="fa fa-shopping-cart h3 p-3 fab-fa-icon"></i>
                <h2>{{'payment_confirm_title' | translate}}</h2>
                <p>
                    {{selectedProduct.newTitle}}
                    <span *ngIf="selectedProduct.type == 0 && selectedProduct.durationHours == 720">
                        {{'gen_per_month' | translate}}
                    </span>
                </p>
                <p class="clr-pri-text-f">{{selectedProduct.description}}</p>
                <p class="mt-3">{{'payment_method_title' | translate}}</p>

                <mat-form-field class="payment-select" appearance="fill">
                    <mat-label>{{'payment_method_title' | translate}}</mat-label>
                    <mat-select [value]="selectedPaymentMethod.id" (selectionChange)="selectPaymentMethod($event)">
                        <mat-option *ngFor="let method of paymentMethods" [value]="method.id">
                            {{method.title | translate}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>

            <!-- Action Buttons -->
            <div class="col-md-12 mt-4 text-center">
                <button class="button bblg sm-100 my-3" (click)="subscribe()">
                    <i class="pr-1 fa fa-check"></i>
                    {{ "gen_ok" | translate}}
                </button>

                <button class="button bblg sm-100 my-3" (click)="closeDialog()">
                    <i class="pr-1 fa fa-times"></i>
                    {{ "gen_cancel" | translate}}
                </button>
            </div>
        </div>
    </section>

    <!-- Waiting Message -->
    <section *ngIf="currentStep == 2">
        <div class="row payment-dialog-container justify-content-center">
            <div class="col-md-12 text-center">
                <i class="h3 p-3 fab-fa-icon" [ngClass]="selectedPaymentMethod.icon"></i>
                <h2>{{"payment_pay_with" | translate}} {{selectedPaymentMethod.title | translate}}</h2>
                <p>{{"payment_redirect_msg" | translate}}</p>
                <p>
                    {{"payment_redirect_window_msg" | translate}}
                    <span class="clr-theme cursor-po-c" (click)="openWindowAgain()">{{"payment_redirect_click"|
                        translate}}</span>
                </p>
                <p>
                    {{'gen_order_id' | translate}}
                    <span class="clr-theme">{{orderId}}</span>
                </p>

                <p>{{"payment_waiting_msg" | translate}}</p>
                <mat-progress-spinner class="mx-auto" [color]="'primary'" [mode]="'indeterminate'" [diameter]="30">
                </mat-progress-spinner>
                <button class="button bblg sm-100 my-3" (click)="cancelPayment()">
                    <i class="pr-1 fa fa-times"></i>
                    {{ "gen_cancel" | translate}}
                </button>
            </div>
        </div>
    </section>

    <!-- Success Message -->
    <section *ngIf="currentStep == 3">
        <div class="row payment-dialog-container justify-content-center">
            <div class="col-md-12 text-center">
                <i class="fa fa-check h3 p-3 fab-fa-icon bg-success text-white"></i>
                <h2>{{"payment_success" | translate}}</h2>
                <p>{{"payment_success_msg" | translate}}</p>

                <button class="button bblg sm-100 my-3" (click)="closeDialog()">
                    {{ "gen_ok" | translate}}
                </button>
            </div>
        </div>
    </section>

    <!-- Fail Message -->
    <section *ngIf="currentStep == 4">
        <div class="row payment-dialog-container justify-content-center">
            <div class="col-md-12 text-center">
                <i class="fa fa-times h3 p-3 fab-fa-icon bg-danger text-white"></i>
                <h2>{{"payment_fail" | translate}}</h2>
                <p>{{"payment_fail_msg" | translate}}</p>

                <button class="button bblg sm-100 my-3" (click)="closeDialog()">
                    {{ "gen_ok" | translate}}
                </button>
            </div>
        </div>
    </section>
</div>